import { render, staticRenderFns } from "./DownloadTicket.vue?vue&type=template&id=87f185ea&"
import script from "./DownloadTicket.vue?vue&type=script&lang=js&"
export * from "./DownloadTicket.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports